import React, { useState } from 'react'
import Text from '../../../../../components/Atomsv2/Text/Text'
import CardDashboard from '../../../../../components/moleculesv2/DashboardCard/CardDashboard'
import Table from '../../../../../components/moleculesv2/Table/Table'
import './CrudConceptos.scss'
import Card from '../../../../../components/Atomsv2/Card/Card'
import Column from '../../../../../components/moleculesv2/Table/Column'
import Button from '../../../../../components/Atomsv2/Button/Button'
import Tooltip from '../../../../../components/Atomsv2/Tooltip/Tooltip'
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel'
import Input from '../../../../../components/Atomsv2/Input/Input'
import Textarea from '../../../../../components/Atomsv2/Textarea/Textarea'
import { crearConcepto, updateConcepto } from '../../integracionPaquetes'
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast'
const CrudConceptos = ({ data, setData }) => {
    const { toasts, addToast, removeToast } = useToast();
    const [sidePanelData, setSidePanelData] = useState(false)
    const [OpenCrear, setOpenCrear] = useState(false)
    const [form, setForm] = useState({
        id: null,
        concepto: null,
        detalle: null,

    })
    const [cards, setCards] = useState([
        {
            title: "1",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        },
        {
            title: "2",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        },
        {
            title: "3",
            icon: "",
            iconColor: "",
            contenido: <Text>Contenido de la tarjeta</Text>,
            footer: <Text size="small" color="var(--gray-dark-500)">Pie de tarjeta</Text>
        }
    ])

    const editarContenido = (rowData) => {
        setForm({
            id: rowData.ID,
            detalle: rowData.DETALLES ?? null,
            concepto: rowData.CONCEPTO ?? null
        })
        setSidePanelData(rowData)
    }
    const editar = async () => {
        if (form.concepto && form.concepto != "") {
            setData(prev => ({
                ...prev,
                conceptos: prev.conceptos.map((item) => {
                    return item.ID == form.id ?
                        {
                            ...item,
                            CONCEPTO: form.concepto,
                            DETALLES: form.detalle
                        }
                        :
                        item
                })
            }))
            await updateConcepto(form)
            limpiar(setSidePanelData)
        }
        else {
            addToast("El campo CONCEPTO es obligatorio", "error", 5000, "light");
        }
    }
    const crear = async () => {
        if (form.concepto && form.concepto != "") {
            let id = null
            await crearConcepto(form)
                .then((res) => {
                    id = res.ID
                })
                .catch((error) => {
                    addToast("error al crear concepto", "error", 5000, "light");

                })
            setData(prev => ({
                ...prev,
                conceptos: [
                    ...prev.conceptos,
                    {
                        ID: id,
                        CONCEPTO: form.concepto,
                        DETALLES: form.detalle
                    }
                ]
            }))
            limpiar(setOpenCrear)
        }
        else {
            addToast("El campo CONCEPTO es obligatorio", "error", 5000, "light");
        }
    }
    const limpiar = (cerrar) => {
        setForm({
            id: null,
            concepto: null,
            detalle: null,
        })
        cerrar(false)
    }
    return (
        <div className='CrudConceptos'>
            <Card>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button style={{ marginBottom: "10px" }} icon='add' onClick={() => { setOpenCrear(true) }}>Nuevo</Button>
                </div>
                <div className="cardsContainer" style={{ marginBottom: "10px" }}>
                    {
                        cards.map((card) => {
                            return (
                                <CardDashboard
                                    title={card.title}
                                    icon={card.icon}
                                    iconColor={card.iconColor}
                                    footer={card.footer}
                                >
                                    {card.contenido}
                                </CardDashboard>
                            )
                        })
                    }

                </div>
                <Table globalFilter data={data?.conceptos} height="calc(100vh - 385px)">
                    <Column sortable header={"ID"} value={"ID"}></Column>
                    <Column sortable header={"CONCEPTO"} value={"CONCEPTO"}></Column>
                    <Column sortable header={"DETALLES"} value={"DETALLES"} body={(rowData) => { return (rowData.DETALLES == null ? "Sin detalles" : rowData.DETALLES) }}></Column>
                    <Column header={"EDITAR"} body={(rowData) => { return (<Tooltip content={"Editar contenido"}><Button onClick={() => { editarContenido(rowData) }} icon="edit"></Button></Tooltip>) }}></Column>
                </Table>
            </Card>
            <SidePanel tabToClose={false} title={"Editar concepto"} subtitle={"Realiza modificaciones de los conceptos."} icon={"edit"} open={sidePanelData} onClose={() => { limpiar(setSidePanelData) }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}><Button onClick={() => { editar() }} icon={"save"}>Guardar</Button></div>
                <Input label='Concepto' placeholder={"Ingresa un Concepto "} value={form.concepto} onChange={(e) => { setForm(prev => ({ ...prev, concepto: e.target.value })) }}></Input>
                <Textarea label='Detalle' placeholder={"Ingresa un Detalle "} value={form.detalle} onChange={(e) => { setForm(prev => ({ ...prev, detalle: e.target.value })) }}></Textarea>
            </SidePanel>

            <SidePanel tabToClose={false} title="Agregar concepto" icon='add' subtitle={"Agrega nuevos conceptos"} open={OpenCrear} onClose={() => { limpiar(setOpenCrear) }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}><Button onClick={() => { crear() }} icon={"save"}>Crear</Button></div>
                <Input label='Concepto' placeholder={"Ingresa un Concepto "} value={form.concepto} onChange={(e) => { setForm(prev => ({ ...prev, concepto: e.target.value })) }}></Input>
                <Textarea label='Detalle' placeholder={"Ingresa un Detalle "} value={form.detalle} onChange={(e) => { setForm(prev => ({ ...prev, detalle: e.target.value })) }}></Textarea>
            </SidePanel>
            <ToastContainer toasts={toasts} removeToast={removeToast} />

        </div>
    )
}
export default CrudConceptos